import { FC } from 'react'

import { Avatar, Box, Button, List, Text, useToggle } from '@factorialco/deprecated-design-system'
import { PerformanceProcessTemplateAuthorFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { ReplaceAuthorModal } from './ReplaceAuthorModal'

type Props = {
  template: PerformanceProcessTemplateAuthorFragment
}

export const TemplateAuthor: FC<Props> = ({ template }) => {
  const author = template.author
  const [showReplaceAuthorModal, toggleShowReplaceAuthorModal] = useToggle()

  if (!author) return null
  return (
    <>
      <Box gap="s32">
        <Box gap="s16">
          <Text size="300" color="grey1000" weight="semibold">
            {i18n.t('performance_process.reviews.templates.owners.section_title')}
          </Text>
          <Text.Normal size="200">
            {i18n.t('performance_process.reviews.templates.owners.section_description')}
          </Text.Normal>
        </Box>
        <Box>
          <List>
            <List.Item key={author.id}>
              <Box flexDirection="row" alignItems="center" gap="s16">
                <Avatar size="s32" url={buildUrl(author.avatar)} label={author.fullName} />
                <Text.Normal weight="medium">
                  {author.fullName}{' '}
                  {author.current && i18n.t('performance_process.reviews.templates.owners.you')}
                </Text.Normal>
              </Box>
              <Button
                type="secondary"
                iconName="replace"
                onClick={toggleShowReplaceAuthorModal(true)}
              />
            </List.Item>
          </List>
        </Box>
      </Box>
      {showReplaceAuthorModal && (
        <ReplaceAuthorModal
          templateId={template.id}
          author={template.author}
          onClose={toggleShowReplaceAuthorModal(false)}
        />
      )}
    </>
  )
}
